import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '../helper/httpService';
import { Constants } from '../helper/constants';

import { PcnModel } from '../viewmodels/pcn.model';
import { StorageService } from './storage.service';
import decimal from 'decimal.js';
// import { KeyDescriptionViewModel } from "../viewmodels/keyDescriptionViewModel";
// import { ContraventionValidationViewModel } from "../viewmodels/contravention-validation-viewmodel";
// import { StageViewModel } from "../viewmodels/stage-viewmodel";
// import { GetPcnViewModel } from "../viewmodels/pcn-get-viewmodel.model";
// import { CreateUpdatePcnViewModel } from "../viewmodels/pcn-crud-viewmodel.model";
// import { ChargeViewModel } from "../viewmodels/chargeViewModel";

@Injectable()
export class PcnBlockService {
  private pcnblockServiceUrl = Constants.serverUrl + 'api/pcn/';

  constructor(
    public http: HttpService,
    private storageService: StorageService
  ) {}

  /** getDefaultPcnPrefix */
  getDefaultPcnPrefix(): Observable<any> {
    return this.http.Get(this.pcnblockServiceUrl + 'getDefaultPcnPrefix');
  }

  /** getPcn */
  getPcn(pcnNumber: string): Observable<any> {
    const url = `${this.pcnblockServiceUrl}getPcn/${pcnNumber}`;
    // console.log('url', url);

    return this.http.Get(url);
  }

  /** getStages */
  getStages(contravention: string, source: number, stage: number, fine: decimal): Observable<any> {
    return this.http.Get(
      this.pcnblockServiceUrl +
        'getStages/' +
        contravention +
        '/' +
        source +
        '/' +
        stage +
        '/' +
        fine
    );
  }

  /* ## Letter Text Types ## */
  getLetterTextTypes(): Observable<any> {
    return this.http.Get(this.pcnblockServiceUrl + 'getLetterTextSets');
  }
  setLetterText(textResourceGroup: string): Observable<any> {
    return this.http.Get(this.pcnblockServiceUrl + 'setLetterText/' + textResourceGroup);
  }

  /* ## Letter Templates ## */
  getLetterTemplates(): Observable<any> {
    return this.http.Get(this.pcnblockServiceUrl + 'getLetterTemplates');
  }
  setLetterTemplate(templateName: string) {
    return this.http.Get(this.pcnblockServiceUrl + 'setLetterTemplate/' + templateName);
  }

  /** checkPcnIsAvailable */
  checkPcnIsAvailable(pcnNumber: string): Observable<any> {
    return this.http.Get(this.pcnblockServiceUrl + 'checkPcnIsAvailable' + '/' + pcnNumber);
  }

  checkPcnPanelLocked() {
    return this.storageService.isPcnPanelLocked();
    // if (localStorage.getItem('rm_pcn_panel_locked') === 'true') {
    //   return true;
    // } else {
    //   localStorage.setItem('rm_pcn_panel_locked', 'false');
    //   return false;
    // }
  }

  togglePcnPanelLocked() {
    const locked = this.storageService.lockPcnPanel(!this.storageService.isPcnPanelLocked());
    return locked;
    // if (localStorage.getItem('rm_pcn_panel_locked') === 'false') {
    //   localStorage.setItem('rm_pcn_panel_locked', 'true');
    //   return true;
    // } else {
    //   localStorage.setItem('rm_pcn_panel_locked', 'false');
    //   return false;
    // }
  }

  /** setPcn */
  setPcn(pcnNumber: string, pcnModel: PcnModel, pcnExists): Observable<any> {
    // console.log("Update PCN (setPcn)");
    const data = JSON.stringify(pcnModel);
    const setPcnUrl = pcnExists ? 'setPcn' : 'saveNewPcn';
    return this.http.Post(this.pcnblockServiceUrl + setPcnUrl + '/' + pcnNumber, data);
  }

  processInterfacedPcn(pcnModel: PcnModel): Observable<any> {
    const data = JSON.stringify(pcnModel);
    return this.http.Post(this.pcnblockServiceUrl + 'processInterfacedPcn', data);
  }

  /** setPcn */
  saveNewPcn(pcnNumber: string, pcnModel: PcnModel): Observable<any> {
    const data = JSON.stringify(pcnModel);
    return this.http.Post(this.pcnblockServiceUrl + 'saveNewPcn' + '/' + pcnNumber, data);
  }

  reOpenPcn(pcnNumber: string) {
    const data = pcnNumber;
    return this.http.Get(this.pcnblockServiceUrl + 'reOpenPcn' + '/' + pcnNumber);
  }

  /** save new contravention */
  saveNewContravention(pcnNumber: string, newContravention: number) {
    const data = JSON.stringify(newContravention);
    return this.http.Post(this.pcnblockServiceUrl + 'saveNewContravention' + '/' + pcnNumber, data);
  }

  // /** checkContraventionIsValid */
  // checkContraventionIsValid(contravention: string): Observable<boolean> {
  //   return this.http.get(this.pcnblockServiceUrl +
  //     'checkContraventionIsValid' +
  //     '/' +
  //     contravention
  //   )
  //     .map((res: Response) => res.json());
  // }

  /** getChargeNowBySelectedStage */
  getChargeNowBySelectedStage(stageId: number, contravention: string): Observable<any> {
    // if (selectedStageDescription.includes('/')) {
    //   selectedStageDescription = selectedStageDescription.replace('/', '');
    // }

    return this.http.Get(
      this.pcnblockServiceUrl + 'getChargeNowBySelectedStage/' + stageId + '/' + contravention
    );
  }

  setSelectedStage(selectedStage: string) {
    return this.http.Get(this.pcnblockServiceUrl + 'setSelectedStage/' + selectedStage);
  }

  /* setLocalPcn */
  setLocalPcn(pcnDetails: PcnModel): void {
    // localStorage.setItem('rm_pcn', JSON.stringify(pcnDetails));
    this.storageService.setPcn(pcnDetails);
  }

  /* getLocalPcn */
  getLocalPcn(): PcnModel {
    return this.storageService.getPcn();
    // return JSON.parse(localStorage.getItem('rm_pcn'));
  }

  /** setClosePcn */
  setClosePcn(close: boolean): void {
    this.storageService.setPcnClosed(close);
    // localStorage.setItem('rm_pcn_closed', JSON.stringify(close));
  }

  /** isPcnClosed */
  isPcnClosed(): boolean {
    return this.storageService.isPcnClosed();
    // if (localStorage.getItem('rm_pcn_closed')) {
    //   return JSON.parse(localStorage.getItem('rm_pcn_closed'));
    // }
    // return false;
  }

  validateContravention(contravention: string): Observable<any> {
    return this.http.Get(this.pcnblockServiceUrl + 'validateContravention' + '/' + contravention);
  }

  /** generatePcn */
  generatePcn(pcnPrefix: string): Observable<any> {
    // Construct the API endpoint
    const url = `${this.pcnblockServiceUrl}generatePcn/${pcnPrefix}`;
    // console.log('Generate PCN URL:', url);

    // Make the GET request
    return this.http.Get(url);
  }
}
